import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";

@Injectable({ providedIn: 'root' })
export class SqaService {
	sectorID: any;
	noskey: string;
	data: any;
	statusRole: string;
	ApprovedStatus: string;
	coreId;
	linkExpoStatusRole: string;
	nosCategory: string;
	constructor(private apiService: ApiService) { }

	saveNOS(NOSData) {
		const createNOSUrl = environment.sqaServiceUrl + "/api/sqa/nos";
		return this.apiService.post(createNOSUrl, NOSData);
	}

	getNSQF() {
		const url = `${environment.sqaServiceUrl}/api/sqa/nos/nsqflevel`;
		return this.apiService.get(url);
	}

	editNOS(NOSData) {
		const createNOSUrl = environment.sqaServiceUrl + "/api/sqa/nos";
		return this.apiService.patch(createNOSUrl, NOSData);
	}

	// Update instant NOS
	updateInstantNos(NOSData) {
		const createNOSUrl = environment.sqaServiceUrl + "/api/sqa/nosinstant/request";
		return this.apiService.put(createNOSUrl, NOSData);
	}

	nosApproval(data) {
		const url = `${environment.sqaServiceUrl}/api/sqa/nos/approval`;
		return this.apiService.put(url, data);
	}

	nosQRCSubmission(data) {
		const url = `${environment.sqaServiceUrl}/api/sqa/nos/status`;
		return this.apiService.put(url, data);
	}

	nosReviewApproval(data) {
		const url = `${environment.sqaServiceUrl}/api/sqa/nos/approve`;
		return this.apiService.put(url, data);
	}

	getNOS() {
		const getNOSUrl =
			environment.sqaServiceUrl +
			"/api/sqa/nos/search?matches=status:Awaiting Standards Approval&pageNo=-";
		return this.apiService.get(getNOSUrl);
	}

	getNosBySearch(params: {
		sectorId?: any;
		limit: any;
		subsectorId?: any;
		pageNo?: any;
		keyword?: any;
		status?: any;
		searchFor?: any;
		otherSector?: any;
		nsqf?: any;
		nosexcel?: any;
	}) {
		params.keyword = params.keyword ? params.keyword : "";
		if (params.status && params.status !== "") {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? "sectorID:" + params.sectorId + ","
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? "subSectorID:" + params.subsectorId + ","
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? "otherSectorsOf:" + params.otherSector + ","
					: "";
			params.status = "statusID:" + params.status;
			params.nsqf = "";
		} else if (params.otherSector && params.otherSector !== "") {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? ",sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? (params.sectorId && params.sectorId !== "" ? "" : "") +
					"otherSectorsOf:" +
					params.otherSector
					: "";
			params.status = "";
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? "nsqf:" + params.nsqf
					: "";
		} else {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? "sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? (params.sectorId && params.sectorId !== "" ? "" : "") +
					"otherSectorsOf:" +
					params.otherSector
					: "";
			params.status = "";
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? "nsqf:" + params.nsqf
					: "";
		}

		if (params.nosexcel) {
			// NosExcel Download
			const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?excel=true&matches=${params.otherSector}${params.sectorId}
			${params.subsectorId}${params.nsqf}${params.status}&keyword=${params.keyword}&pageNo=
			&size=&searchFor=selfNos&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,Occupation,created_at,updated_at,Acronyms,Glossary,Scope,nextReviewPeriod,nosCategory,deactivationDetails,expository`;
			return this.apiService.getBlob(
				nosBySearchURL,
				"application/vnd.ms-excel"
			);
		} else {
			// NOS search filter
			const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?matches=${params.otherSector}${params.sectorId}
			${params.subsectorId}${params.nsqf}${params.status}&keyword=${params.keyword}&pageNo=${params.pageNo}
			&size=${params.limit}&searchFor=selfNos&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,Occupation,created_at,updated_at,Acronyms,Glossary,Scope,nextReviewPeriod,nosCategory,deactivationDetails,expository,isNosInstantation`;
			return this.apiService.get(nosBySearchURL);
		}
	}

	getNosAllaplicableNosBySearch(
		secID,
		params: {
			sectorId?: any;
			limit: any;
			subsectorId?: any;
			pageNo?: any;
			keyword?: any;
			status?: any;
			searchFor?: any;
			otherSector?: any;
			nsqf?: any;
		}
	) {
		params.keyword = params.keyword ? params.keyword : "";
		if (params.status && params.status !== "") {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? ",sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? "otherSectorsOf:" + params.otherSector + ","
					: "";
			params.status = ",statusID:" + params.status;
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? ",nsqf:" + params.nsqf
					: "";
		} else {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? ",sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? (params.sectorId && params.sectorId !== "" ? ";" : "") +
					"otherSectorsOf:" +
					params.otherSector
					: "";
			params.status = "";
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? ",nsqf:" + params.nsqf
					: "";
		}

		const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?matches=linkqp:${secID}${params.sectorId}
			${params.subsectorId}${params.nsqf}${params.status}&keyword=${params.keyword}&pageNo=${params.pageNo}
			&size=${params.limit}&searchFor=selfNos&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,Occupation,created_at,updated_at,Acronyms,Glossary`;

		return this.apiService.get(nosBySearchURL);
	}
	getMCrAllaplicableNosBySearch(
		secID,
		params: {
			sectorId?: any;
			limit: any;
			subsectorId?: any;
			pageNo?: any;
			keyword?: any;
			status?: any;
			searchFor?: any;
			otherSector?: any;
			nsqf?: any;
		}
	) {
		params.keyword = params.keyword ? params.keyword : "";
		if (params.status && params.status !== "") {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? ",sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? "otherSectorsOf:" + params.otherSector + ","
					: "";
			params.status = ",statusID:" + params.status;
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? ",nsqf:" + params.nsqf
					: "";
		} else {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? ",sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? (params.sectorId && params.sectorId !== "" ? ";" : "") +
					"otherSectorsOf:" +
					params.otherSector
					: "";
			params.status = "";
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? ",nsqf:" + params.nsqf
					: "";
		}

		const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?matches=linkqp:${secID}${params.sectorId}
			${params.subsectorId}${params.nsqf}${params.status}&keyword=${params.keyword}&pageNo=${params.pageNo}
			&size=${params.limit}&searchFor=selfNos&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,Occupation,created_at,updated_at,Acronyms,Glossary`;

		return this.apiService.get(nosBySearchURL);
	}
	getSTFilteredQPList(data) {
		data.sectorId =
			data.sectorId && data.sectorId !== ""
				? "sectorID:" + data.sectorId
				: "";
		data.subSectorId =
			data.subSectorId && data.subSectorId !== ""
				? ",subSectorID:" + data.subSectorId
				: "";
		data.keyword = data.keyword ? data.keyword : "";
		data.status = data.status
			? (data.sectorId && data.sectorId !== "" ? "," : "") +
			"status:" +
			data.status
			: "";
		const url = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${data.pageNo}&size=${data.limit}&search=${data.sectorId}
		${data.subSectorId}${data.status}&keyword=${data.keyword}&fields=nsqfLevel,jobRole,qpCode,qpTitle,sectors,
		occupation,modelCurriculum,status,version`;
		return this.apiService.get(url);
	}

	// get nos details by tempId
	getNOSforParticularNosTempID(nosTempID: string) {
		const getNOSforParticularNosTempIDUrl = `${environment.sqaServiceUrl}/api/sqa/nos/search?matches=nosTempID:${nosTempID}&pageNo=-`;
		return this.apiService.get(getNOSforParticularNosTempIDUrl);
	}

	getNOSforParticularUnitCode(nosUnitCode: string, version?: string) {
		const unitCode = decodeURIComponent(nosUnitCode);
		const getNOSforParticularUnitCodeUrl = `${environment.sqaServiceUrl}/api/sqa/nos`;
		return this.apiService.get(getNOSforParticularUnitCodeUrl, {
			unitCode,
			version,
		});
	}

	createQP(QPData) {
		// tslint:disable-next-line:max-line-length
		if (
			(QPData.status.statusDesc === "Draft" ||
				QPData.status.statusDesc === "Submitted to Standards") &&
			QPData.lastReviewedOn === ""
		) {
			// delete QPData.lastReviewedOn;
			QPData.draftedOn = this.dateToIso(new Date(QPData.draftedOn));
			QPData.nextReviewDate = this.dateToIso(
				new Date(QPData.nextReviewDate)
			);
		}
		const createQPUrl = environment.sqaServiceUrl + "/api/sqa/qp";
		return this.apiService.post(createQPUrl, QPData);
	}

	updateQP(QPData) {
		// tslint:disable-next-line:max-line-length
		if (
			(QPData.status.statusDesc === "Draft" ||
				QPData.status.statusDesc === "Submitted to Standards") &&
			QPData.lastReviewedOn === ""
		) {
			// delete QPData.lastReviewedOn;
			QPData.draftedOn = this.dateToIso(new Date(QPData.draftedOn));
			QPData.nextReviewDate = this.dateToIso(
				new Date(QPData.nextReviewDate)
			);
		}
		const updateQPUrl = environment.sqaServiceUrl + "/api/sqa/qp";
		return this.apiService.put(updateQPUrl, QPData);
	}
	checkQPExistence(QPData) {
		const updateQPUrl = environment.sqaServiceUrl + "/api/sqa/qp/existence/check";
		return this.apiService.post(updateQPUrl, QPData);
	}
	updateQPTaggingParameter(QPData) {
		const updateQPUrl = environment.sqaServiceUrl + "/api/sqa/qp";
		return this.apiService.put(updateQPUrl, QPData);
	}

	isoToDate(iso: string) {
		const date = new Date(iso);
		return (
			date.getFullYear() +
			"/" +
			(date.getMonth() + 1) +
			"/" +
			date.getDate()
		);
	}

	dateToIso(date: Date) {
		return date.toISOString();
	}

	deleteQP(qpData: any) {
		console.log(qpData);
		const deleteQpUrl = `${environment.sqaServiceUrl}/api/sqa/qp?qpTempID=${qpData.qpTempID}&version=${qpData.version}`;
		return this.apiService.delete(deleteQpUrl, {
			qpCode: qpData.qpCode,
			version: qpData.version,
			status: qpData.status,
		});
	}

	getQP(page: number, fields: string, size: number) {
		const getQPUrl = `${environment.sqaServiceUrl}/api/sqa/qp/master?pageNo=${page}&size=${size}&fields=${fields}`;
		return this.apiService.get(getQPUrl);
	}

	getSelectedQP(data: any) {
		const decodeQp = decodeURIComponent(data.qpCode);
		const newQpCode = encodeURIComponent(decodeQp);
		const selectedQPUrl = `${environment.sqaServiceUrl}/api/sqa/qp?qpCode=${newQpCode}&version=${data.version}`;
		return this.apiService.get(selectedQPUrl);
	}

	uploadMultipleQpDocuments(docsData) {
		const qpDocsURL = `${environment.sqaServiceUrl}/api/sqa/qp/docket`;
		return this.apiService.put(qpDocsURL, docsData);
	}

	getAllNos(page?: number, size?: number) {
		const getAllNosUrl =
			page && size
				? `${environment.sqaServiceUrl}/api/sqa/nos/search?pageNo=${page}&size=${size}`
				: `${environment.sqaServiceUrl}/api/sqa/nos/search?pageNo=`;
		return this.apiService.get(getAllNosUrl);
	}

	saveQPReview(data) {
		const saveQPReviewUrl = `${environment.sqaServiceUrl}/api/sqa/qp/review`;
		return this.apiService.put(saveQPReviewUrl, data);
	}

	createNewVersionOfQP(data) {
		const newVersionUrl = `${environment.sqaServiceUrl}/api/sqa/qp/create/version`;
		return this.apiService.post(newVersionUrl, data);
	}

	createNewVersionOfNos(data) {
		const newVersionUrl = `${environment.sqaServiceUrl}/api/sqa/nos/create/version`;
		return this.apiService.post(newVersionUrl, data);
	}

	copyDetailsForNewQp(data) {
		const copyDetailsUrl = `${environment.sqaServiceUrl}/api/sqa/qp/copy`;
		return this.apiService.post(copyDetailsUrl, data);
	}

	copyDetailsForNewNos(data) {
		const copyDetailsUrl = `${environment.sqaServiceUrl}/api/sqa/nos/copy`;
		return this.apiService.post(copyDetailsUrl, data);
	}

	// Create NOS instant 
	createNosInstantRequest(data) {
		const copyDetailsUrl = `${environment.sqaServiceUrl}/api/sqa/nosinstant/request`;
		return this.apiService.post(copyDetailsUrl, data);
	}


	getAllParameters() {
		const qpParamURL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/qpparameters`;
		return this.apiService.get(qpParamURL);
	}
	getBucket() {
		const qpBucketURL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/qpbuckets`;
		return this.apiService.get(qpBucketURL);
	}

	getLoggedInSector() {
		const loggedInSectorURL = `${environment.userServiceUrl}/api/user/v1/loggedInUser`;
		return this.apiService.get(loggedInSectorURL);
	}

	saveExpository(data: any) {
		const expositoryUrl = `${environment.sqaServiceUrl}/api/sqa/expository`;
		return this.apiService.post(expositoryUrl, data);
	}

	updateExpository(data: any) {
		const updateExpURL = `${environment.sqaServiceUrl}/api/sqa/expository`;
		return this.apiService.put(updateExpURL, data);
	}

	getExpositoryByCode(code: string, version?: number) {
		const getExpURL = `${environment.sqaServiceUrl}/api/sqa/expository?expoCode=${code}&version=`;
		return this.apiService.get(getExpURL);
	}

	getAllExpositories(filters: string) {
		// tslint:disable-next-line:max-line-length
		// const getExpURL = `${environment.sqaServiceUrl}/api/sqa/expository/filter?status=${filters.status}&keyword=${filters.keyword}&pageNo=${filters.pageNo}&size=${filters.size}&sortOrder=${filters.sortOrder}&sortBy=${filters.sortBy}&fields=${filters.fields}`;
		const getExpURL = `${environment.sqaServiceUrl}/api/sqa/expository/filter?${filters}`;

		return this.apiService.get(getExpURL);
	}

	expositoryApproval(data: any) {
		const getExpApproval = `${environment.sqaServiceUrl}/api/sqa/expository/approval`;
		return this.apiService.put(getExpApproval, data);
	}

	getQpByQpCode(qpCode: string, version: string, data?) {
		const decodeQp = decodeURIComponent(qpCode);
		var newQpCode = encodeURIComponent(decodeQp);
		const qpCodeURL = `${environment.sqaServiceUrl}/api/sqa/qp?qpCode=${newQpCode}
		&&version=${version}&expoCode=${data && data.expoCode ? data.expoCode : ""}
		&expoVersion=${data && data.expoVersion ? data.expoVersion : ""}`;
		return this.apiService.get(qpCodeURL);
	}

	getNosByUnitCode(unitCode: string, version: string) {
		const decodeQp = decodeURIComponent(unitCode);
		var newQpCode = encodeURIComponent(decodeQp);
		const qpCodeURL = `${environment.sqaServiceUrl}/api/sqa/nos?unitCode=${newQpCode}&version=${version}`;
		return this.apiService.get(qpCodeURL);
	}

	getQpByTempId(tempId: string, version: string) {
		const qpCodeURL = `${environment.sqaServiceUrl}/api/sqa/qp?qpCode=&version=${version}&qpTempID=${tempId}`;
		return this.apiService.get(qpCodeURL);
	}

	getNosDataBySearch(
		search,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		loggedInUser?: any,
		role?: any,
		nosExcel?: any
	) {
		if (role === "QRC") {
			this.noskey = "QRC";
		} else if (role === "NSQC") {
			this.noskey = "NSQC";
		} else if (role === "allnos") {
			this.noskey = "allnos";
		} else {
			this.noskey = "ST";
		}
		if (
			(loggedInUser === "Standards QRC" &&
				(role === "QRC" || role === "NSQC")) ||
			(loggedInUser === "Standards NSQC" &&
				(role === "QRC" || role === "NSQC")) ||
			loggedInUser === "Standards Team"
		) {
			this.nosCategory = "standalone";
		} else {
			this.nosCategory = "";
		}

		let searchkey = "userbased:true";
		if (sectorID) {
			searchkey += `,sectorID:${sectorID}`;
			if (subectorID) {
				searchkey += `,subSectorID:${subectorID}`;
			}
		}
		if (pageStatus) {
			searchkey += `,statusID:${pageStatus}`;
		}
		if (nosExcel) {
			// stNosExcel Download
			const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?excel=true&role=${this.noskey}&
			matches=${searchkey}&keyword=${search}&pageNo=&size=&searchFor=self&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at`;
			return this.apiService.getBlob(
				nosBySearchURL,
				"application/vnd.ms-excel"
			);
		} else {
			// stNosExcel filter
			const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?nosCategory=${this.nosCategory}&role=${this.noskey}&
			matches=${searchkey}&keyword=${search}&pageNo=${pageno}&size=${size}&searchFor=self&
			fields=unitCode,nosTempID,Sectors,unitTitle,deactivationDetails,qrcApproval,nsqcApproval,qrcFeedback,nextReviewDate,updated_at,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at,nosCategory`;
			return this.apiService.get(nosBySearchURL);
		}
	}
	getMCDataBySearch(
		search,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		loggedInUser?: any,
		role?: any,
		nosExcel?: any
	) {
		if (role === "QRC") {
			this.noskey = "QRC";
		} else if (role === "NSQC") {
			this.noskey = "NSQC";
		} else if (role === "allnos") {
			this.noskey = "allnos";
		} else {
			this.noskey = "ST";
		}
		this.nosCategory = "microcredential";
		// if (
		// 	(loggedInUser === "Standards QRC" &&
		// 		(role === "QRC" || role === "NSQC")) ||
		// 	(loggedInUser === "Standards NSQC" &&
		// 		(role === "QRC" || role === "NSQC")) ||
		// 	loggedInUser === "Standards Team"
		// ) {
		// 	this.nosCategory = "microcredential";
		// } else {
		// 	this.nosCategory = "";
		// }

		let searchkey = "userbased:true";
		if (sectorID) {
			searchkey += `,sectorID:${sectorID}`;
			if (subectorID) {
				searchkey += `,subSectorID:${subectorID}`;
			}
		}
		if (pageStatus) {
			searchkey += `,statusID:${pageStatus}`;
		}
		if (nosExcel) {
			// stNosExcel Download
			const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?nosCategory=${this.nosCategory}&excel=true&role=${this.noskey}&
			matches=${searchkey}&keyword=${search}&pageNo=&size=&searchFor=self&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at,trainingDeliveryMode,nosCategory`;
			return this.apiService.getBlob(
				nosBySearchURL,
				"application/vnd.ms-excel"
			);
		} else {
			// stNosExcel filter
			const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?nosCategory=${this.nosCategory}&role=${this.noskey}&
			matches=${searchkey}&keyword=${search}&pageNo=${pageno}&size=${size}&searchFor=self&
			fields=unitCode,nosTempID,Sectors,unitTitle,deactivationDetails,qrcApproval,nsqcApproval,qrcFeedback,nextReviewDate,updated_at,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at,nosCategory,trainingDeliveryMode`;
			return this.apiService.get(nosBySearchURL);
		}
	}
	getNosExcelDownload(
		search,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		role?: any
	) {
		if (role === "QRC") {
			this.noskey = "QRC";
		} else if (role === "NSQC") {
			this.noskey = "NSQC";
		} else if (role === "allnos") {
			this.noskey = "allnos";
		} else {
			this.noskey = "ST";
		}

		let searchkey = "userbased:true";
		if (sectorID) {
			searchkey += `,sectorID:${sectorID}`;
			if (subectorID) {
				searchkey += `,subSectorID:${subectorID}`;
			}
		}
		if (pageStatus) {
			searchkey += `,statusID:${pageStatus}`;
		}

		// stNosExcel Download
		const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?excel=true&role=${this.noskey}&
			matches=${searchkey}&keyword=${search}&pageNo=&size=&searchFor=self&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at`;
		return this.apiService.getBlob(
			nosBySearchURL,
			"application/vnd.ms-excel"
		);
	}
	getMCExcelDownload(
		search,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		role?: any
	) {
		if (role === "QRC") {
			this.noskey = "QRC";
		} else if (role === "NSQC") {
			this.noskey = "NSQC";
		} else if (role === "allnos") {
			this.noskey = "allnos";
		} else {
			this.noskey = "ST";
		}

		let searchkey = "userbased:true";
		if (sectorID) {
			searchkey += `,sectorID:${sectorID}`;
			if (subectorID) {
				searchkey += `,subSectorID:${subectorID}`;
			}
		}
		if (pageStatus) {
			searchkey += `,statusID:${pageStatus}`;
		}

		// stNosExcel Download
		const nosBySearchURL = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?excel=true&role=${this.noskey}&
			matches=${searchkey}&keyword=${search}&pageNo=&size=&searchFor=self&
			fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at`;
		return this.apiService.getBlob(
			nosBySearchURL,
			"application/vnd.ms-excel"
		);
	}

	updateQpWithAditionalDetails(data) {
		const qpDetailsURL = `${environment.sqaServiceUrl}/api/sqa/qp/additionalDtls`;
		return this.apiService.put(qpDetailsURL, data);
	}

	getQpWithAdditionalDetails(qpCode: string, version: string) {
		const qpDetailsURL = `${environment.sqaServiceUrl}/api/sqa/qp/additionalDtls?qpCode=${qpCode}&version=${version}`;
		return this.apiService.get(qpDetailsURL);
	}
	uploadNosDocument(docsData) {
		const nosDocURL = `${environment.sqaServiceUrl}/api/sqa/nos/docket`;
		return this.apiService.put(nosDocURL, docsData);
	}

	getStatusList() {
		const statusURL = `${environment.sqaServiceUrl}/api/sqa/qp/status`;
		return this.apiService.get(statusURL);
	}

	getNOsStatusList() {
		const statusURL = `${environment.sqaServiceUrl}/api/sqa/nos/status`;
		return this.apiService.get(statusURL);
	}

	getQpByStatus(status) {
		const qpStatusURL = `${environment.sqaServiceUrl}/api/sqa/qp/approval/${status}`;
		return this.apiService.get(qpStatusURL);
	}

	getQpListBySearch(
		search,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		qpExcel?: any,
		isInstance?: boolean,
		instanceCode?: any
	) {
		let searchkey = "";
		if (isInstance) {
			searchkey += "nsqc:true";
		} else {
			searchkey += "standardsTeam:true";
		}
		searchkey += ",borrowType:notborrowed";
		if (sectorID) {
			searchkey += `,sectorID:${sectorID}`;
			if (subectorID) {
				searchkey += `,subSectorID:${subectorID}`;
			}
		}
		if (pageStatus) {
			searchkey += `,statusID:${pageStatus}`;
		}
		if (isInstance) {
			searchkey += `,instantiatedqps:${isInstance}`;
		}
		if (qpExcel) {
			if (isInstance) {
				// stQPExcel Download
				const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?instanceqpExcel=true&role=ST&pageNo=&keyword=${search}&size=&fields=qpCode,status,sectors,nsqfLevel,originSSC,jobRole,callBackRemarks,country,reviews,deactivationDetails,updated_at,version,certificateName&search=${searchkey}`;
				return this.apiService.getBlob(
					qpSearchURL,
					"application/vnd.ms-excel"
				);
			} else {
				// stQPExcel Download
				const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?excel=true&role=ST&pageNo=&keyword=${search}&size=&fields=qpCode,status,sectors,nsqfLevel,jobRole,callBackRemarks,country,reviews,originSSC,deactivationDetails,updated_at,version&search=${searchkey}`;
				return this.apiService.getBlob(
					qpSearchURL,
					"application/vnd.ms-excel"
				);
			}
		} else {
			// stQPExcel filter
			const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&keyword=${search}&size=${size}
			&fields=qpCode,status,sectors,nsqfLevel,jobRole,callBackRemarks,country,reviews,instanceCode,deactivationDetails,certificateName,originSSC,updated_at,version&search=${searchkey}`;
			return this.apiService.get(qpSearchURL);
		}
	}
	getQPJobRolesList() {
		const jobRoleURL = `${environment.sqaServiceUrl}/api/sqa/qp/jobroles?fields=qpCode`;
		return this.apiService.get(jobRoleURL);
	}
	getEquipmentDetails() {
		const equipmentURL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/equipments`;
		return this.apiService.get(equipmentURL);
	}
	getMinimumEducationForSchool() {
		const minimumEduURL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/educationalqualificationsforschools`;
		return this.apiService.get(minimumEduURL);
	}
	getMinimumEducationList() {
		const minimumEduURL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/educationalqualifications?sort=true`;
		return this.apiService.get(minimumEduURL);
	}
	getQpList(keyword, pageNo, size) {
		const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageNo}&size=${size}&fields=jobRole,qpCode,qpTitle,sectors,
		occupation,nsqfLevel,modelCurriculum,status,version&keyword=${keyword}&search=status:NSQC Approved`;
		return this.apiService.get(qpSearchURL);
	}
	borrowQPBySSC(qpdata) {
		const borrowURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow`;
		return this.apiService.put(borrowURL, qpdata);
	}
	getBorrowedQpRequestList(pageNo, size) {
		const borrowedQpRequestListURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrowreq?pageNo=${pageNo}&size=${size}`;
		return this.apiService.get(borrowedQpRequestListURL);
	}
	getBorrowedQpData(data) {
		const selectedQPUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrowreq?search=qpCode:${data.qpCode},
		version:${data.version},sectorID:${data.sectorID}`;
		return this.apiService.get(selectedQPUrl);
	}

	approvalOfBorrowQp(borrowQpdata) {
		const borrowURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/approval`;
		return this.apiService.put(borrowURL, borrowQpdata);
	}

	deleteNos(nosTempID, version, status) {
		const nosDeleteURL = `${environment.sqaServiceUrl}/api/sqa/nos?tempID=${nosTempID}&version=${version}&statusID=${status}`;
		return this.apiService.delete(nosDeleteURL);
	}
	recallNOSFromSSC(data) {
		const borrowURL1 = `${environment.sqaServiceUrl}/api/sqa/nos/recall`;
		return this.apiService.put(borrowURL1, data);
	}

	recallQPFromSSC(data) {
		const borrowURL2 = `${environment.sqaServiceUrl}/api/sqa/qp/recall`;
		return this.apiService.put(borrowURL2, data);
	}

	generatePdf(qpCode: string, version: string) {
		// const pdfUrl = `${environment.pdfGenerate}/api/v1/generatepdfreports/qp-report/?qpCode=${qpCode}&version=${version}`;
		// return this.apiService.getBlob(pdfUrl, 'application/pdf');
		const pdfUrl = `${environment.pdfGenerate}/api/v1/generatepdfreports/qp-report/v1-2/?qpCode=${qpCode}&version=${version}`;
		return this.apiService.get(pdfUrl);
		// return this.apiService.get(pdfUrl, 'application/json');
	}

	// qppdf
	generateQpPdf(qpCode: string, version: string, qpData?) {
		const expoCode = qpData && qpData.expository && qpData.expository[0] && qpData.expository[0].expoCode ? qpData.expository[0].expoCode : "";
		const expoVersion = qpData && qpData.expository && qpData.expository[0] && qpData.expository[0].version ? qpData.expository[0].version : "";

		const pdfUrl = `${environment.pdfGenerate}/api/v1/pdf/qp-report/?qpCode=${qpCode}&version=${version}&expoCode=${expoCode}&expoVersion=${expoVersion}`;
		return this.apiService.get(pdfUrl);
	}

	// qppdf for SCPWD qp listing
	generateScpwdQpPdf(
		qpCode: string,
		version: string,
		expoCode: string,
		expoVersion: string
	) {
		const pdfUrl = `${environment.pdfGenerate}/api/v1/pdf/qp-report/?qpCode=${qpCode}&version=${version}&expoCode=${expoCode}&expoVersion=${expoVersion}`;
		return this.apiService.get(pdfUrl);
	}

	// qpPdf tempid
	generateQpTempIdPdf(qpTempID: string) {
		const pdfUrl = `${environment.pdfGenerate}/api/v1/pdf/qp-report/?qpTempID=${qpTempID}`;
		return this.apiService.get(pdfUrl);
	}

	// nosPDF
	generateNosUnitCodePdf(unitCode: string, version: string, nosData?) {
		const expoCode = nosData && nosData.expository && nosData.expository[0] && nosData.expository[0].expoCode ? nosData.expository[0].expoCode : "";
		const expoVersion = nosData && nosData.expository && nosData.expository[0] && nosData.expository[0].version ? nosData.expository[0].version : "";

		const pdfUrl = `${environment.pdfGenerate}/api/v1/pdf/nos-report/?unitCode=${unitCode}&version=${version}&expoCode=${expoCode}&expoVersion=${expoVersion}`;
		return this.apiService.get(pdfUrl);
	}

	// nosTempid
	generateNosTempIdPdf(nosTempID: string) {
		const pdfUrl = `${environment.pdfGenerate}/api/v1/pdf/nos-report/?nosTempID=${nosTempID}`;
		return this.apiService.get(pdfUrl);
	}

	getNosofQP(qpCode: string, version: any) {
		const URL = `${environment.sqaServiceUrl
			}/api/sqa/qp/nos?qpCode=${encodeURIComponent(
				qpCode
			)}&version=${version}`;
		return this.apiService.get(URL);
	}
	// *******  for borrowed-qp-listing  **********
	getBorrowedQPList() {
		const URL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/list`;
		return this.apiService.get(URL);
	}

	// PDF file download :begins
	getBorrowedQPDownlod(qpCode: string, version: any) {
		const URL = `${environment.pdfGenerate}/api/v1/pdf/borrowed-qp-report?qpCode=${qpCode}&version=${version}&borrowKey=true`;
		return this.apiService.get(URL);
	}
	// PDF file: End

	// ******  End ************

	// ****  Scpw-borrow-qp-listing:begins  *****
	getScpwBorrowedQPList() {
		const URL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/list?type=Scpwd`;
		return this.apiService.get(URL);
	}

	getScpwBorrowedQPListV1(queryParams) {
		let URL =
			`${environment.sqaServiceUrl}/api/sqa/qp/borrow/list?type=Scpwd` +
			queryParams;
		// const URL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/list?type=ScpwdpageNo=${pageNo}&size=${limit}`
		return this.apiService.get(URL);
	}

	fileUpload(data: any) {
		console.log(data);
		const formData: FormData = new FormData();
		formData.append("file", data.file);
		const URL = `${environment.sqaServiceUrl}/api/sqa/nos/upload`;
		return this.apiService.post(URL, formData);
	}

	// expo upload excel
	expoFileUpload(data: any) {
		console.log(data);
		const formData: FormData = new FormData();
		formData.append("file", data.file);
		const URL = `${environment.sqaServiceUrl}/api/sqa/expository/upload`;
		return this.apiService.post(URL, formData);
	}

	// multipleqp doc attachement
	multiQpDocsAtach(multiQpData) {
		const multiQp = `${environment.sqaServiceUrl}/api/sqa/qp/docket`;
		return this.apiService.put(multiQp, multiQpData);
	}

	//multiple Nos Docs Attach
	multipleNosDocsAtach(multiQpData) {
		const multipleNos = `${environment.sqaServiceUrl}/api/sqa/nos/docket`;
		return this.apiService.put(multipleNos, multiQpData);
	}

	submitForQrcApproval(qrcData) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/qp/submit`;
		return this.apiService.put(dataUrl, qrcData);
	}

	submitForQrcApprovalForNos(qrcData) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/nos/submit`;
		return this.apiService.put(dataUrl, qrcData);
	}

	markAsQrcrNsqcApproved(qrcData) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/qp/review`;
		return this.apiService.put(dataUrl, qrcData);
	}

	markAsQrcrNsqcApprovedForNos(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/nos/approval`;
		return this.apiService.put(dataUrl, data);
	}
	createOccupation(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/occupation`;
		return this.apiService.post(dataUrl, data);
	}

	deleteOccupation(data) {
		const deleteUrl = `${environment.sqaServiceUrl}/api/sqa/occupation?occupationID=${data}`;
		return this.apiService.delete(deleteUrl);
	}

	updateOccupation(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/occupation`;
		return this.apiService.put(dataUrl, data);
	}

	getAllOccupations(sectorID, pageNo?, size?) {
		const getOccUrl = `${environment.sqaServiceUrl}/api/sqa/occupation?sectorID=${sectorID}&pageNo=1&size=10`;
		return this.apiService.get(getOccUrl);
	}

	getAllOccupationsList(sectorID) {
		const getOccUrl = `${environment.sqaServiceUrl}/api/sqa/occupation?sectorID=${sectorID}`;
		return this.apiService.get(getOccUrl);
	}

	getAllNsqcrQrcData(
		key,
		search,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		qpExcel?: any
	) {
		var role = "";
		role += "borrowType:notborrowed";
		if (key === "qrc") {
			role += `,qrc:true,instantiatedqps:false`;
		} else if (key === "nsqc") {
			role += `,nsqc:true,instantiatedqps:false`;
		} else if (key === "allqps") {
			role += `,allqps:true,instantiatedqps:false`;
		}
		if (sectorID) {
			role += `,sectorID:${sectorID}`;
			if (subectorID) {
				role += `,subSectorID:${subectorID}`;
			}
		}
		if (pageStatus) {
			role += `,statusID:${pageStatus}`;
		}
		if (qpExcel) {
			// stQPExcel Download
			const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?excel=true&role=${this.statusRole}&pageNo=&size=&keyword=${search}&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,callBackRemarks,remarks,country,reviews,deactivationDetails,qrcApproval,nsqcApproval,qrcFeedback,nextReviewDate,updated_at,version&search=${role}`;
			return this.apiService.getBlob(
				qrcDataURL,
				"application/vnd.ms-excel"
			);
		} else {
			// stQPExcel filter
			const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&size=${size}&keyword=${search}&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,callBackRemarks,remarks,country,reviews,deactivationDetails,qrcApproval,nsqcApproval,qrcFeedback,nextReviewDate,updated_at,version&search=${role}`;
			return this.apiService.get(qrcDataURL);
		}
	}

	getAllCreatedUsers(
		userName?,
		specialization?,
		userType?,
		keyword?,
		pageNo?,
		size?,
		status?
	) {
		const userDataUrl = `${environment.sqaServiceUrl}/api/sqa/externaluser/search?pageNo=${pageNo}&&size=${size}&&userName=${userName}&&specializationName=${specialization}&&name=${keyword}&&userType=${userType}`;
		return this.apiService.get(userDataUrl);
	}

	submitToMembers(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/qp/feedback/submitToMembers`;
		return this.apiService.post(dataUrl, data);
	}

	getAssignedUSers(qpCode, version) {
		const dataURL = `${environment.sqaServiceUrl}/api/sqa/qp/GetUserDetails?qpCode=${qpCode}&version=${version}`;
		return this.apiService.get(dataURL);
	}

	submitToMembersForNOS(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/nos/feedback/submitToMembers`;
		return this.apiService.post(dataUrl, data);
	}
	getAssignedUSersForNOS(unitCode, version) {
		const dataURL = `${environment.sqaServiceUrl}/api/sqa/nos/GetUserDetails?unitCode=${unitCode}&version=${version}`;
		return this.apiService.get(dataURL);
	}

	getListOfAllQPsforFeedBack(
		key,
		keyword,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subectorID?: any,
		pageStatus?: any,
		qpExcel?: any,
		borrowType?: any
	) {
		var role;
		if (key) {
			role = `qrcFeedback:${key}`;
		}
		if (borrowType) {
			role += `,borrowType:${borrowType}`;
		}
		if (borrowType === "pwd") {
			if (sectorID) {
				role += `,originSectorID:${sectorID}`;
				if (subectorID) {
					role += `,originSubSector:${subectorID}`;
				}
			}
		} else {
			if (sectorID) {
				role += `,sectorID:${sectorID}`;
				if (subectorID) {
					role += `,subSectorID:${subectorID}`;
				}
			}
		}

		if (pageStatus) {
			role += `,statusID:${pageStatus}`;
		}
		if (qpExcel) {
			// stQPExcel Download
			if (key === "pending") {
				var excelValue = "qrcfeedbackpending";
			} else {
				var excelValue = "qrcfeedbackreviewed";
			}
			if (borrowType === "notBorrowed") {
				const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?excel=true&role=${excelValue}&pageNo=&size=&keyword=${keyword}&fields=qpCode,status,sectors,nsqfLevel,occupation,createdOn,jobRole,country,nextReviewDate,qrcApproval,version&search=${role}`;
				return this.apiService.getBlob(
					qrcDataURL,
					"application/vnd.ms-excel"
				);
			} else {
				const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?borrowqpLinkexpoExcel=true&role=${excelValue}&pageNo=&size=&keyword=${keyword}&fields=qpCode,status,sectors,nsqfLevel,occupation,createdOn,jobRole,country,nextReviewDate,qrcApproval,expository,originSSC,version&search=${role}`;
				return this.apiService.getBlob(
					qrcDataURL,
					"application/vnd.ms-excel"
				);
			}
		} else {
			const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&size=${size}&keyword=${keyword}&fields=qpCode,status,sectors,nsqfLevel,occupation,createdOn,jobRole,country,nextReviewDate,qrcApproval,expository,originSSC,originSSC,expository,version&search=${role}`;
			return this.apiService.get(qrcDataURL);
		}
	}

	getListOfAllNOSforFeedBack(
		key,
		selectedTab,
		keyword,
		pageno?: number,
		size?: number,
		sectorID?: any,
		subSectorID?: any,
		nosExcel?: any
	) {
		var role;
		if (key) {
			role = `qrcFeedback:${key}`;
		}
		if (nosExcel) {
			if (key === "pending") {
				var excelValue = "qrcfeedbackpending";
			} else {
				var excelValue = "qrcfeedbackreviewed";
			}
			const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?role=${excelValue}&pageNo=${pageno}&size=${size}&keyword=${keyword}&excel=true&fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at,nosCategory,Sectors,qrcFeedback&matches=qrcFeedback:${selectedTab},borrowType:notBorrowed,sectorID:${sectorID},subSectorID:${subSectorID}`;
			return this.apiService.getBlob(
				qrcDataURL,
				"application/vnd.ms-excel"
			);
		} else {
			const qrcDataURL = `${environment.sqaServiceUrl}/api/sqa/nos/search?role=allnos&
			pageNo=${pageno}&size=${size}&keyword=${keyword}&fields=unitCode,nosTempID,Sectors,
			unitTitle,credits,version,nsqf,Status,qrcApproval,nsqcApproval,
			PerformanceCriteria,description,Reviews,remarks,callBackRemarks,updated_at,nosCategory,
			Sectors,qrcFeedback&matches=qrcFeedback:${selectedTab},borrowType:notBorrowed,
			sectorID:${sectorID},subSectorID:${subSectorID}`;
			return this.apiService.get(qrcDataURL);
		}
	}

	submitQRCMemberFeedBack(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/qp/feedback`;
		return this.apiService.post(dataUrl, data);
	}

	submitQRCMemberFeedBackNOS(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/nos/feedback`;
		return this.apiService.post(dataUrl, data);
	}

	getProviedFeedBack(qpCode, version) {
		const getDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/feedback?qpCode=${qpCode}&&version=${version}`;
		return this.apiService.get(getDataURL);
	}

	getProviedFeedBackForNOS(unitCode, version) {
		const getDataURL = `${environment.sqaServiceUrl}/api/sqa/nos/feedback?unitCode=${unitCode}&&version=${version}`;
		return this.apiService.get(getDataURL);
	}

	updateNextReviewDate(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/qp/nextreviewdate`;
		return this.apiService.put(requestURL, data);
	}

	updateNOSNextReviewDate(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/nos/nextreviewdate`;
		return this.apiService.put(requestURL, data);
	}

	approveOrRejectDeactivationReq(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/qp/deactivation/review`;
		return this.apiService.put(requestURL, data);
	}

	approveOrRejectDeactivationNOSReq(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/nos/deactivation/review`;
		return this.apiService.put(requestURL, data);
	}

	getAllDeactivationRequests(
		type,
		pageNo,
		size,
		sectorID?,
		subSectorID?,
		statusID?,
		raisedBy?,
		keyword?,
		isInstance?
	) {
		// const decodeType = decodeURIComponent(type)
		const getDataURL = `${environment.sqaServiceUrl}/api/sqa/qp/deactivationlist?pageNo=${pageNo}&&size=${size}&&reqStatus=${type}&&sectorID=${sectorID}&&subSectorID=${subSectorID}&&statusID=${statusID}&&raisedBy=${raisedBy}&&search=${keyword}&isQpInstantation=${isInstance}`;
		return this.apiService.get(getDataURL);
	}

	getAllDeactivationNOSRequests(
		type,
		pageNo,
		size,
		sectorID?,
		subSectorID?,
		statusID?,
		raisedBy?,
		keyword?,
		nosCategory?,
		isNosInstantation?
	) {
		// const decodeType = decodeURIComponent(type)
		const getDataURL = `${environment.sqaServiceUrl}/api/sqa/nos/deactivationlist?pageNo=${pageNo}&size=${size}&reqStatus=${type}&sectorID=${sectorID}&subSectorID=${subSectorID}&statusID=${statusID}&raisedBy=${raisedBy}&search=${keyword}&nosCategory=${nosCategory}&isNosInstantation=${isNosInstantation}`;
		return this.apiService.get(getDataURL);
	}

	raiseDeactivationRequest(formData) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/qp/deactivation/create`;
		return this.apiService.post(URL, formData);
	}

	raiseNOSDeactivationRequest(formData) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/nos/deactivation/create`;
		return this.apiService.post(URL, formData);
	}

	downloadFile(url) {
		const getFile = `${environment.documentServiceUrl}/api/document/v1/signedURL?key=${url}`;
		return this.apiService.get(getFile);
	}

	downloadExpositoryPDF(url) {
		const getFile = `${environment.documentServiceUrl}/api/document/v1/signedURL/public?key=${url}`;
		return this.apiService.get(getFile);
	}

	// deactivation qplisting
	deactivationQPListing() {
		const URL = `${environment.sqaServiceUrl}/api/sqa/qp/deactivatedqps`;
		return this.apiService.get(URL);
	}
	getEqtInfo(queryParams) {
		const dataUrl =
			`${environment.sqaServiceUrl}/api/sqa/equipment?` + queryParams;
		return this.apiService.get(dataUrl);
	}
	getUnitTypes() {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/list/units`;
		return this.apiService.get(dataUrl);
	}
	getTrainerPrerequisiteData(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/trainerprerequisitedetails`;
		return this.apiService.put(dataUrl, data);
	}
	getTrainerPrerequisite(query) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/qp/search?${query}`;
		return this.apiService.get(dataUrl);
	}
	updateSpecsForDisclaimer(data) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/specification`;
		return this.apiService.put(URL, data);
	}
	getFinalReviews(eqptData) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/equipment`;
		return this.apiService.put(URL, eqptData);
	}
	getQPEquList(query) {
		const dataUrl =
			`${environment.sqaServiceUrl}/api/sqa/qp/listEquipments?` + query;
		return this.apiService.get(dataUrl);
	}
	getQpNosList(query) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/nos/search?${query}`;
		return this.apiService.get(dataUrl);
	}
	submitNewEquipment(eqptData) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/equipment`;
		return this.apiService.post(dataUrl, eqptData);
	}
	getUnitTypeData() {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/list/units`;
		return this.apiService.get(dataUrl);
	}
	updateInactive(queryParams) {
		const URL =
			`${environment.sqaServiceUrl}/api/sqa/qp/equipment/inactivate?` +
			queryParams;
		return this.apiService.get(URL);
	}
	submitLabAreaSpec(labAreaSpecData) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/labarea`;
		return this.apiService.post(dataUrl, labAreaSpecData);
	}
	getLabData(data) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/labareadetails`;
		return this.apiService.put(dataUrl, data);
	}
	getSubSector(sectorId) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/sectors/subsectors/${sectorId}`;
		return this.apiService.get(dataUrl);
	}
	getNsqfLevel() {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/nos/nsqflevel`;
		return this.apiService.get(dataUrl);
	}
	getQpStatus() {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/qp/status`;
		return this.apiService.get(dataUrl);
	}
	getQps(queryParams) {
		const dataUrl =
			`${environment.sqaServiceUrl}/api/sqa/qp/search?` + queryParams;
		return this.apiService.get(dataUrl);
	}
	submitReviewLabAreaSpec(labAreaSpecData, id) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/labarea`;
		return this.apiService.put(dataUrl, labAreaSpecData);
	}

	submitReviewTrainerPreRequsite(trainerData, id) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/trainerprerequisite`;
		return this.apiService.put(dataUrl, trainerData);
	}
	submitTrainerPreRequsite(trainerData) {
		const dataUrl = `${environment.sqaServiceUrl}/api/sqa/trainerprerequisite`;
		return this.apiService.post(dataUrl, trainerData);
	}
	setData(jobRoleData: any) {
		this.data = jobRoleData;
	}
	checkingexistingTrainer(qpCode) {
		const URL =
			`${environment.sqaServiceUrl}/api/sqa/tp/validate?qpCode=` + qpCode;
		return this.apiService.get(URL);
	}

	// homepage-qplisting search filter
	getQpListingBySearch(queryParams) {
		// stQPExcel filter
		const qpBySearchURL =
			`${environment.sqaServiceUrl}/api/sqa/qp/homepagelist?` +
			queryParams;
		return this.apiService.get(qpBySearchURL);
	}
	getQpListBySector(queryParams) {
		// stQPExcel filter
		const qpBySearchURL =
			`${environment.sqaServiceUrl}/api/sqa/qp/pmv?` +
			queryParams;
		return this.apiService.get(qpBySearchURL);
	}
	
	getQpListingBySearchV1(queryParams) {
		// stQPExcel filter
		if (queryParams) {
			const qpBySearchURL =
				`${environment.sqaServiceUrl}/api/sqa/qp/homepagelist?` +
				queryParams;
			return this.apiService.get(qpBySearchURL);
		}
	}

	// homepage-qplisting Excel Download
	getQpListingExcelDownload(queryParams) {
		// stQPExcel Download
		const qpBySearchURL =
			`${environment.sqaServiceUrl}/api/sqa/qp/homepagelist?` +
			queryParams;
		return this.apiService.getBlob(
			qpBySearchURL,
			"application/vnd.ms-excel"
		);
	}

	// deactiveQP excel download
	deactiveQPExcelDownload(queryParams) {
		const url =
			environment.sqaServiceUrl +
			"/api/sqa/qp/homepagelist?" +
			queryParams;
		return this.apiService.getBlob(url, "application/vnd.ms-excel");
	}

	getNOSListingBySearch(queryParams) {
		const nosBySearchURL =
			`${environment.sqaServiceUrl}/api/sqa/nos/homepagelist?` +
			queryParams;
		return this.apiService.get(nosBySearchURL);
	}
	getMicroCredListingBySearch(queryParams) {
		const nosBySearchURL =
			`${environment.sqaServiceUrl}/api/sqa/microcredential/homepagelist?` +
			queryParams;
		return this.apiService.get(nosBySearchURL);
	}
	deactiveNOSExcelDownload(queryParams) {
		const url =
			environment.sqaServiceUrl +
			"/api/sqa/nos/homepagelist?" +
			queryParams;
		return this.apiService.getBlob(url, "application/vnd.ms-excel");
	}
	deactiveMCExcelDownload(queryParams) {
		const url =
			environment.sqaServiceUrl +
			"/api/sqa/microcredential/homepagelist?" +
			queryParams;
		return this.apiService.getBlob(url, "application/vnd.ms-excel");
	}
	// BorrowQP
	borrowQPRequestFromSSC(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/request`;
		return this.apiService.post(requestURL, data);
	}

	updateBorrowQPRequestFromSSC(data, isQPTagging?) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/request?isQPTagging=${isQPTagging}`;
		return this.apiService.put(requestURL, data);
	}

	createModelCurricullam(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/createcurricullam`;
		return this.apiService.post(requestURL, data);
	}

	getModelCurricullamqp(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/getmcqp`;
		return this.apiService.get(requestURL, data);
	}

	getQPData(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/getqp`;
		return this.apiService.get(requestURL, data);
	}

	deactivatedModelCurricullam(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/deactivate`;
		return this.apiService.post(requestURL, data);
	}

	reactivateModelCurricullam(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/reactivatemc`;
		return this.apiService.post(requestURL, data);
	}


	submitMcReview(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/mcreview`;
		return this.apiService.post(requestURL, data);
	}

	getAllScpwdQps(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/getscpwdqps`
		return this.apiService.get(requestURL, data);
	}

	getALLMCRequests(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/getallcurricullam`;
		return this.apiService.get(requestURL, data)
	}

	updateMCRequest(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/curricullam/updatemodelcurricullam`;
		return this.apiService.post(requestURL, data);
	}

	getAllNosMC(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/getallnos`;
		return this.apiService.get(requestURL, data);
	}

	getNosMC(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/getNos`;
		return this.apiService.get(requestURL, data);
	}

	getModelCurriculumNos(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum//getNosMC`;
		return this.apiService.get(requestURL, data);
	}

	createModelCurriculumNos(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/createnosmc`;
		return this.apiService.post(requestURL, data);
	}

	getAllModelCurriculumNos(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/getAllnosmc`;
		return this.apiService.get(requestURL, data);
	}

	ApproveNosModelCurricullam(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/submitnosreview`;
		return this.apiService.post(requestURL, data);
	}

	deactivateNosModelCurriculum(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/deactivatenosmc`;
		return this.apiService.post(requestURL, data);
	}

	raiseReactivationRequestNosModelCurriculum(data) {
		const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/reactivatenosmc`;
		return this.apiService.post(requestURL, data);
	}

	downloadNOSMCExcelData(data) {
		// const requestURL = `${environment.learningServiceUrl}/api/v1/learning/noscurriculum/nosmcexceldownload`;
		// return this.apiService.get(requestURL, "application/vnd.ms-excel");
		const requestURL =
			`${environment.learningServiceUrl}/api/v1/learning/public/nosmcexceldownload?` +
			data;
		// console.log("==========> requested Url", requestURL);
		return this.apiService.getBlob(
			requestURL,
			"application/vnd.ms-excel"
		);
	}

	getAllNosModelCurriculum(data) {
		const resquestURL = `${environment.learningServiceUrl}/api/v1/learning/public/nosmodelcurriculum`;
		return this.apiService.get(resquestURL, data);
	}

	deleteBorrowQP(data) {
		const deleteQpUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/request?qpTempID=${data.qpTempID}&version=${data.version}`;
		return this.apiService.delete(deleteQpUrl);
	}

	getAllBorrowedQPRequests(
		role: any,
		pageno: number,
		size: number,
		borrowSSC?: any,
		originateSS?: any,
		statusInfo?: any,
		keyword?: any,
		qpExcel?: any
	) {
		let searchkey = "";
		if (role === "standardsTeam") {
			searchkey += "standardsTeam:true";
			this.statusRole = "ST";
		} else if (role === "borrowingCommittee") {
			searchkey += "borrowCommittee:true";
			this.statusRole = "BC";
		}

		searchkey += ",borrowType:ssc";
		if (borrowSSC) {
			searchkey += `,sectorID:${borrowSSC}`;
		}
		if (originateSS) {
			searchkey += `,originSectorID:${originateSS}`;
		}
		if (statusInfo) {
			searchkey += `,statusID:${statusInfo}`;
		}
		if (qpExcel) {
			// excel Download
			const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?borrowqpExcel=true&role=${this.statusRole}&pageNo=&keyword=${keyword}
			&size=&fields=qpCode,status,sectors,nsqfLevel,jobRole,callBackRemarks,country,reviews,updated_at,originSSC,version&search=${searchkey}`;
			return this.apiService.getBlob(
				qpSearchURL,
				"application/vnd.ms-excel"
			);
		} else {
			// search filter
			const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&keyword=${keyword}&size=${size}
			&fields=qpCode,status,sectors,nsqfLevel,jobRole,callBackRemarks,country,reviews,updated_at,originSSC,borrowCommittee,version&search=${searchkey}`;
			return this.apiService.get(qpSearchURL);
		}
	}
	getAllSCPWDBorrowedQPRequests(
		role: any,
		pageno: number,
		size: number,
		borrowSSC?: any,
		originateSS?: any,
		statusInfo?: any,
		keyword?: any,
		qpExcel?: any
	) {
		let searchkey = "";
		if (role === "standardsTeam") {
			searchkey += "standardsTeam:true";
			this.linkExpoStatusRole = "ST";
		} else if (role === "qrc") {
			searchkey += "qrc:true";
			this.linkExpoStatusRole = "QRC";
		} else if (role === "nsqc") {
			searchkey += "nsqc:true";
			this.linkExpoStatusRole = "NSQC";
		}
		searchkey += ",borrowType:pwd";
		if (borrowSSC) {
			searchkey += `,sectorID:${borrowSSC}`;
		}
		if (originateSS) {
			searchkey += `,originSectorID:${originateSS}`;
		}
		if (statusInfo) {
			searchkey += `,statusID:${statusInfo}`;
		}
		if (qpExcel) {
			// excel Download
			const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?borrowqpLinkexpoExcel=true&role=${this.linkExpoStatusRole}&pageNo=&keyword=${keyword}&size=
			&fields=qpCode,status,sectors,nsqfLevel,jobRole,callBackRemarks,country,reviews,updated_at,originSSC,expository,version&search=${searchkey}`;
			return this.apiService.getBlob(
				qpSearchURL,
				"application/vnd.ms-excel"
			);
		} else {
			// search filter
			const qpSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&keyword=${keyword}&size=${size}
			&fields=qpCode,status,sectors,nsqfLevel,jobRole,callBackRemarks,country,reviews,updated_at,originSSC,expository,qrcApproval,nsqcApproval,version&search=${searchkey}`;
			return this.apiService.get(qpSearchURL);
		}
	}

	reviewBorrowQPRequest(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/review `;
		return this.apiService.put(requestURL, data);
	}
	reviewSCPWDBorrowQPRequest(data) {
		const requestURL = `${environment.sqaServiceUrl}/api/sqa/qp/scpwd/review `;
		return this.apiService.put(requestURL, data);
	}

	getLatestVersionOfQP(qpCode, version) {
		const getOccUrl = `${environment.sqaServiceUrl}/api/sqa/qp/latestversion?qpCode=${qpCode}&version=${version}`;
		return this.apiService.get(getOccUrl);
	}

	getAllDisabilityTypes() {
		const getAllDisabilityTypesUrl =
			environment.nsdcCommonServiceUrl + "/api/nsdccommon/disability/v";
		return this.apiService.get(getAllDisabilityTypesUrl);
	}

	getAllDisabilityCategories() {
		const url =
			environment.nsdcCommonServiceUrl +
			"/api/nsdccommon/disabilitycategory/1";
		return this.apiService.get(url);
	}

	getAllExpositoryStatus() {
		const url = environment.sqaServiceUrl + "/api/sqa/expository/status";
		return this.apiService.get(url);
	}

	saveNewExpository(data: any) {
		const SaveExpositoryUrl =
			environment.sqaServiceUrl + "/api/sqa/expository";
		return this.apiService.post(SaveExpositoryUrl, data);
	}

	UpdateExpositoryDetails(data: any) {
		const UpdateExpositoryUrl =
			environment.sqaServiceUrl + "/api/sqa/expository";
		return this.apiService.put(UpdateExpositoryUrl, data);
	}

	copyDetailsForNewExpository(data) {
		const copyDetailsUrl = `${environment.sqaServiceUrl}/api/sqa/expository/copy`;
		return this.apiService.post(copyDetailsUrl, data);
	}

	createNewVersionOFExpository(data) {
		const newVersionUrl = `${environment.sqaServiceUrl}/api/sqa/expository/create/version`;
		return this.apiService.post(newVersionUrl, data);
	}

	saveLinkExpoToQpDetails(data: any) {
		const saveLinkExpoQpUrl =
			environment.sqaServiceUrl + "/api/sqa/qp/borrow";
		return this.apiService.post(saveLinkExpoQpUrl, data);
	}

	updateBorrowQpRequest(data: any) {
		const updateLinkExpoQpUrl =
			environment.sqaServiceUrl + "/api/sqa/qp/borrow";
		return this.apiService.put(updateLinkExpoQpUrl, data);
	}

	getAllBorrowedQpDetails(pageNo, itemPerPage, query?) {
		let queryParams = {};
		queryParams["pageNo"] = pageNo;
		queryParams["itemsPerPage"] = itemPerPage;
		if (query) {
			queryParams = Object.assign({}, queryParams, query);
		}

		const getAllDetailsUrl =
			environment.sqaServiceUrl + "/api/sqa/qp/borrow/filter";
		return this.apiService.get(getAllDetailsUrl, queryParams);
	}

	getBorrowQpDataBySearch(data: {
		qpCode;
		pageno?: number;
		size?: number;
		sectorID?: any;
		subsectorID?: any;
		status?: any;
		nsqf?: any;
	}) {
		data.qpCode = data.qpCode ? data.qpCode : "";
		console.log("params", data.qpCode);
		if (data.status && data.status !== "") {
			data.sectorID =
				data.sectorID && data.sectorID !== ""
					? "sectorID:" + data.sectorID + ","
					: "";
			data.subsectorID =
				data.subsectorID && data.subsectorID !== ""
					? "subSectorID:" + data.subsectorID + ","
					: "";
			data.status = "statusID:" + data.status;
			data.nsqf =
				data.nsqf && data.nsqf !== "All"
					? "nsqfLevel:" + data.nsqf + ","
					: "";
			// data.nsqf = '';
		} else if (data.nsqf && data.nsqf !== "All") {
			data.sectorID =
				data.sectorID && data.sectorID !== ""
					? "sectorID:" + data.sectorID + ","
					: "";
			data.subsectorID =
				data.subsectorID && data.subsectorID !== ""
					? ",subSectorID:" + data.subsectorID
					: "";
			data.status = "";
			data.nsqf =
				data.nsqf && data.nsqf !== "All"
					? "nsqfLevel:" + data.nsqf
					: "";
		} else {
			data.sectorID =
				data.sectorID && data.sectorID !== ""
					? "sectorID:" + data.sectorID
					: "";
			data.subsectorID =
				data.subsectorID && data.subsectorID !== ""
					? ",subSectorID:" + data.subsectorID
					: "";
			data.status = "";
			data.nsqf = "";
		}
		const dataSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/filter?
		matches=${data.sectorID}${data.subsectorID}${data.nsqf}${data.status}&keyword=${data.qpCode}&pageNo=${data.pageno}&size=${data.size}`;
		return this.apiService.get(dataSearchURL);
	}

	getExpoDataByReqId(reqId: any) {
		const getExpoDataByReqIdUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow?reqID=${reqId}`;
		return this.apiService.get(getExpoDataByReqIdUrl);
	}

	getExpoDataByReqCode(reqCode: any) {
		const getExpoDataByReqIdUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow?reqCode=${reqCode}`;
		return this.apiService.get(getExpoDataByReqIdUrl);
	}

	deleteBorrowQpRequest(reqID: any) {
		const deleteBorrowQpRequestUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow?reqID=${reqID}`;
		return this.apiService.delete(deleteBorrowQpRequestUrl);
	}

	requestForCallback(data: any) {
		const SaveExpositoryUrl =
			environment.sqaServiceUrl + "/api/sqa/expository";
		return this.apiService.put(SaveExpositoryUrl, data);
	}

	getViewAllExpositoryDetails(pageNo, itemPerPage, query?, status?) {
		let queryParams = {};
		queryParams["pageNo"] = pageNo;
		queryParams["size"] = itemPerPage;
		if (query) {
			queryParams = Object.assign({}, queryParams, query);
		}
		if (status === "Standards Approved") {
			this.ApprovedStatus = `filter?matches=statusID:7`;
		} else {
			this.ApprovedStatus = "filter";
		}
		const getViewAllDetailsUrl =
			environment.sqaServiceUrl +
			`/api/sqa/expository/${this.ApprovedStatus}`;
		return this.apiService.get(getViewAllDetailsUrl, queryParams);
	}

	deleteExpository(exptmpID: any, expoversion: any) {
		const deleteExpositoryUrl = `${environment.sqaServiceUrl}/api/sqa/expository?tempID=${exptmpID}&version=${expoversion}`;
		return this.apiService.delete(deleteExpositoryUrl, {
			tempID: exptmpID,
			version: expoversion,
		});
	}

	getViewExpository(id: any) {
		const getExpositoryUrl = `${environment.sqaServiceUrl}/api/sqa/expository/filter?matches=exptmpID:${id}`;
		return this.apiService.get(getExpositoryUrl);
	}

	getViewExpositoryDetails(expoCode: any, version: any) {
		const getExpositoryDetailsUrl = `${environment.sqaServiceUrl}/api/sqa/expository?expoCode=${expoCode}&version=${version}`;
		return this.apiService.get(getExpositoryDetailsUrl);
	}

	getUploadFiles(url: any) {
		const getUploadFilesUrl = `${environment.documentServiceUrl}/api/document/v1/signedURL?key=${url}`;
		return this.apiService.get(getUploadFilesUrl);
	}

	searchExpoData(
		disabilitytype: any,
		disabilitycategory: any,
		status: any,
		keyword: any,
		pageNo: any,
		itemsPerPage: any,
		excel?: boolean
	) {
		// ,pageNo:any,itemsPerPage:any
		var disabilityUrl = "";
		var disabilitycategoryUrl = "";
		var statusUrl = "";
		if (disabilitytype) {
			disabilityUrl = "disabilitytype:" + disabilitytype + ",";
		}
		if (disabilitycategory) {
			disabilitycategoryUrl =
				"disabilitycategory:" + disabilitycategory + ",";
		}
		if (status) {
			statusUrl = "statusID:" + status;
		}
		if (keyword) {
			keyword = keyword;
		} else {
			keyword = "";
		}
		var seachData = disabilityUrl + disabilitycategoryUrl + statusUrl;
		var expositorySearch = seachData.replace(/,\s*$/, "");
		// &pageNo=${pageNo}&itemsPerPage=${itemsPerPage}&
		let searchExpoURL;
		if (!excel) {
			searchExpoURL = `${environment.sqaServiceUrl}/api/sqa/expository/filter?matches=${expositorySearch}&pageNo=${pageNo}&size=${itemsPerPage}&keyword=${keyword}`;
		} else {
			searchExpoURL = `${environment.sqaServiceUrl}/api/sqa/expository/filter?matches=${expositorySearch}&pageNo=&size=&keyword=${keyword}&excel=${excel}`;
			return this.apiService.getBlob(
				searchExpoURL,
				"application/vnd.ms-excel"
			);
		}
		return this.apiService.get(searchExpoURL);
	}

	ApprovedExpositoryDetails(data: any) {
		const getApprovedDetailsUrl =
			environment.sqaServiceUrl + "/api/sqa/expository/approval";
		return this.apiService.put(getApprovedDetailsUrl, data);
	}

	// borrow QP Services

	getAllOtherSectorData(
		search?: any,
		pageno?: number,
		size?: number,
		standardsTeam?: boolean,
		coreSector?: boolean
	) {
		console.log(search.status);
		console.log(coreSector);
		if (coreSector === false) {
			if (search.sectorID == 40) {
				this.coreId = "excludeSectorID";
			} else {
				this.coreId = "excludeSectorID:40,sectorID";
			}
		} else {
			this.coreId = "sectorID";
			if (search.sectorID !== 40) {
				search.sectorID = 40;
			}
		}
		console.log(this.coreId);
		// tslint:disable-next-line:max-line-length
		let searchUrl =
			search.sectorID !== "All"
				? `${this.coreId}:${search.sectorID}`
				: ``;
		searchUrl +=
			search.subSectorID !== "All" && search.subSectorID !== ""
				? `,subSectorID:${search.subSectorID}`
				: ``;
		searchUrl += search.nsqf !== "All" ? `,nsqf:${search.nsqf}` : ``;
		searchUrl +=
			search.status !== "All"
				? `,status:${search.status.statusDesc}`
				: ``;
		// tslint:disable-next-line:max-line-length
		const qpDataURL = standardsTeam
			? `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&&size=${size}&&search=${searchUrl}&keyword=${search.keyword}&
				&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version&search=standardsTeam:true`
			: `${environment.sqaServiceUrl}/api/sqa/qp/search?search=${searchUrl}&keyword=${search.keyword}&pageNo=${pageno}&size=${size}&
				&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version,draftedOn,updated_at`;
		return this.apiService.get(qpDataURL);
	}

	getBorowQPDetails(search?: any, pageno?: number, size?: number) {
		// http://localhost:3009/api/sqa/qp/search?search=sectorID:13&keyword=&pageNo=1&size=10&&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version,draftedOn,updated_at,deactivationDetails,nextReviewDate,originSSC,borrowReviews
		// ,isBorrowed=true

		// let searchUrl = (search.sectorID !== 'All' && search.sectorID !== '') ? '40' : '';

		let searchUrl = "sectorID:40";
		searchUrl +=
			search.subSectorID !== "All" && search.subSectorID !== ""
				? `,subSectorID:${search.subSectorID}`
				: "";
		searchUrl += search.nsqf !== "All" ? `,nsqf:${search.nsqf}` : "";
		searchUrl +=
			search.status !== "All" ? `,statusID:${search.status}` : "";

		// let searchUrl =  (search.status !== 'All') ? `,statusID:${search.status}` : '';

		// const url = `${environment.sqaServiceUrl}/api/sqa/qp/search?search=${searchUrl}&sectorID:40&keyword=${search.keyword}&pageNo=${pageno}&size=${size}&&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version,draftedOn,updated_at,deactivationDetails,nextReviewDate,originSSC,borrowReviews`;
		// return this.apiService.get(url);

		const url = `${environment.sqaServiceUrl}/api/sqa/qp/search?search=${searchUrl}&keyword=${search.keyword}&pageNo=${pageno}&size=${size}&&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version,draftedOn,updated_at,deactivationDetails,nextReviewDate,originSSC,borrowReviews`;
		return this.apiService.get(url);
	}

	getBorrowQpDataByReqId(reqId: any) {
		const getExpoDataByReqIdUrl = `${environment.sqaServiceUrl}/api/sqa/get/qp?qpTempID=${reqId}`;
		return this.apiService.get(getExpoDataByReqIdUrl);
	}

	deleteBorrowedQp(qpTempID) {
		const url = `${environment.sqaServiceUrl}/api/sqa/delete/expos?qpTempID=${qpTempID}`;
		return this.apiService.delete(url);
	}

	saveLinkExpoToQp(data: any) {
		const url =
			environment.sqaServiceUrl + "/api/sqa/update/borrowQp/expository";
		return this.apiService.post(url, data);
	}

	updateLinkExpoToQp(data: any) {
		const url = environment.sqaServiceUrl + "/api/sqa/edit/expos";
		return this.apiService.put(url, data);
	}

	getDataByQp(qpcode, version) {
		const selectedQPUrl = `${environment.sqaServiceUrl}/api/sqa/qp?qpCode=${qpcode}&version=${version}`;
		return this.apiService.get(selectedQPUrl);
	}

	getReviewhistory(qpcode, version) {
		const url = `${environment.sqaServiceUrl}/api/sqa/borrowrequest/reviews?version=${version}&qpCode=${qpcode}`;
		return this.apiService.get(url);
	}

	getAllExpositoriesForBorrowQP(
		pageNo,
		size,
		disabilitytype,
		disabilitycat,
		expoStatus,
		expoCode
	) {
		const url = `${environment.sqaServiceUrl}/api/sqa/expository/get/approvedexpo?pageNo=${pageNo}&size=${size}&disabilitytype=${disabilitytype}&disabilitycat=${disabilitycat}&expoStatus=${expoStatus}&search=${expoCode}`;
		return this.apiService.get(url);
	}

	createInstanceOfQP(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/qpinstant/request";
		return this.apiService.post(url, data);
	}

	updateQPInstanceDetails(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/qpinstant/request";
		return this.apiService.put(url, data);
	}

	createSubSector(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/sectors/subsector";
		return this.apiService.post(url, data);
	}

	resubmitSubSector(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/sectors/subsector";
		return this.apiService.put(url, data);
	}

	getAddedSubSectorList(payload?) {
		const status = payload && payload.status ? payload.status : "";
		const sectorId = payload && payload.sector ? payload.sector : "";

		const url =
			environment.sqaServiceUrl +
			`/api/sqa/sectors/subsector/workflow?status=${status}&sectorId=${sectorId}`;
		return this.apiService.get(url);
	}

	actionOnSubsectorApprovalRequest(data?) {
		const url =
			environment.sqaServiceUrl + `/api/sqa/sectors/subsector/approval`;
		return this.apiService.put(url, data);
	}

	// downloadExpositoryPDF(url){
	//     const getFile = `${environment.documentServiceUrl}/api/document/v1/signedURL/public?key=${url}`
	//     return this.apiService.get(getFile)
	// }

	createOccupationForSector(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/sectors/occupation";
		return this.apiService.post(url, data);
	}

	updateOccupationForSector(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/sectors/occupation";
		return this.apiService.put(url, data);
	}

	getAddedOccupationList(payload?) {
		const status = payload && payload.status ? payload.status : "";
		const sectorId = payload && payload.sector ? payload.sector : "";

		const url =
			environment.sqaServiceUrl +
			`/api/sqa/sectors/occupation/workflow?status=${status}&sectorId=${sectorId}`;
		return this.apiService.get(url);
	}

	actionOnOccupationApprovalRequest(data?) {
		const url =
			environment.sqaServiceUrl + `/api/sqa/sectors/occupation/approval`;
		return this.apiService.put(url, data);
	}
	updateRplEquipment(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/equipment/enablerpl";
		return this.apiService.put(url, data);
	}
	createEquipment(data) {
		const url = environment.sqaServiceUrl + "/api/sqa/equipment/addFromList";
		return this.apiService.put(url, data);
	}
	getReactivationQPRequests() {
		const url = environment.sqaServiceUrl + `/api/sqa/qp/reactivationlist`;
		return this.apiService.get(url);
	}

	raiseRequestForQPActivation(data) {
		const url = environment.sqaServiceUrl + `/api/sqa/qp/reactivation/create`
		return this.apiService.post(url, data);
	}

	raiseRequestForNOSActivation(data) {
		const url = environment.sqaServiceUrl + `/api/sqa/nos/reactivation/create`
		return this.apiService.post(url, data);
	}

	takeActionForQPReactivation(payload) {
		const url = environment.sqaServiceUrl + `/api/sqa/qp/reactivation/review`;
		return this.apiService.put(url, payload);
	}

	getReactivationNOSRequests(type, nosCategory) {
		const url = environment.sqaServiceUrl + `/api/sqa/nos/reactivationlist?reqStatus=${type}&nosCategory=${nosCategory}`;
		return this.apiService.get(url);
	}

	takeActionForNOSReactivation(payload) {
		const url = environment.sqaServiceUrl + `/api/sqa/nos/reactivation/review`;
		return this.apiService.put(url, payload);
	}

	fetchEquipmentFromLowerVersion(query) {
		const url = environment.sqaServiceUrl + `/api/sqa/qp/getlistEquipments?qp=${query.qp}&version=${query.version}`;
		return this.apiService.get(url);
	}

	saveMicroCredential(payload) {
		const url = environment.sqaServiceUrl + `/api/sqa/microcredential`;
		return this.apiService.post(url, payload);
	}


	editMicroCredential(payload) {
		const url = environment.sqaServiceUrl + `/api/sqa/microcredential`;
		return this.apiService.patch(url, payload);
	}

	getMicroCredential(
		params: {
			sectorId?: any;
			limit: any;
			subsectorId?: any;
			pageNo?: any;
			keyword?: any;
			status?: any;
			searchFor?: any;
			otherSector?: any;
			nsqf?: any;
			nosexcel?: any;
		}) {
		params.keyword = params.keyword ? params.keyword : "";
		if (params.status && params.status !== "") {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? "sectorID:" + params.sectorId + ","
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? "subSectorID:" + params.subsectorId + ","
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? "otherSectorsOf:" + params.otherSector + ","
					: "";
			params.status = "statusID:" + params.status;
			params.nsqf = "";
		} else if (params.otherSector && params.otherSector !== "") {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? ",sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? (params.sectorId && params.sectorId !== "" ? "" : "") +
					"otherSectorsOf:" +
					params.otherSector
					: "";
			params.status = "";
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? "nsqf:" + params.nsqf
					: "";
		} else {
			params.sectorId =
				params.sectorId && params.sectorId !== ""
					? "sectorID:" + params.sectorId
					: "";
			params.subsectorId =
				params.subsectorId && params.subsectorId !== ""
					? ",subSectorID:" + params.subsectorId
					: "";
			params.otherSector =
				params.otherSector && params.otherSector !== ""
					? (params.sectorId && params.sectorId !== "" ? "" : "") +
					"otherSectorsOf:" +
					params.otherSector
					: "";
			params.status = "";
			params.nsqf =
				params.nsqf && params.nsqf !== "All"
					? "nsqf:" + params.nsqf
					: "";
		}

		if (params.nosexcel) {
			// NosExcel Download
			const mcBySearchURL = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?excel=true&matches=${params.otherSector}${params.sectorId}
				${params.subsectorId}${params.nsqf}${params.status}&keyword=${params.keyword}&pageNo=
				&size=&searchFor=selfNos&
				fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,Occupation,created_at,updated_at,Acronyms,Glossary,Scope,nextReviewPeriod,nosCategory,deactivationDetails,expository`;
			return this.apiService.getBlob(
				mcBySearchURL,
				"application/vnd.ms-excel"
			);
		} else {
			const mcBySearchURL = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?matches=${params.otherSector}${params.sectorId}
				${params.subsectorId}${params.nsqf}${params.status}&keyword=${params.keyword}&pageNo=${params.pageNo}
				&size=${params.limit}&searchFor=selfNos&
				fields=unitCode,nosTempID,Sectors,unitTitle,credits,version,nsqf,Status,PerformanceCriteria,description,Reviews,Occupation,created_at,updated_at,Acronyms,Glossary,Scope,nextReviewPeriod,nosCategory,deactivationDetails,expository,reactivationDetails,isNosInstantation,nosInstantation.unitCode,nosInstantation.version`;
			return this.apiService.get(mcBySearchURL);
		}

	}

	getMCforParticularNosTempID(nosTempID: string) {
		const getMCforParticularNosTempIDUrl = `${environment.sqaServiceUrl}/api/sqa/microcredential/search?matches=nosTempID:${nosTempID}&pageNo=-`;
		return this.apiService.get(getMCforParticularNosTempIDUrl);
	}
	
	getPlatformJobRoleForPMKVY(type){
		const url = environment.sqaServiceUrl + `/api/sqa/platform/qp?isTrainerAssessor=${type}`;
		return this.apiService.get(url);
	}


}

export const NOS_MOCK = [
	{
		unitCode: "JHF/N3254",
		unitTitle: "UG",
		version: "1.0",
		sectorID: "2",
		sectorName: "Apparel",
		subSectorID: "8",
		subSectorName: "Horticulture",
		isCompulsory: true,
		isUnique: true,
	},
	{
		unitCode: "AAA/N6765",
		unitTitle: "625",
		version: "1.0",
		sectorID: "2",
		sectorName: "Apparel",
		subSectorID: "3",
		subSectorName: "Farm Mechanisation",
		isCompulsory: true,
		isUnique: true,
	},

];
